import { NeedsTransportResponse } from "../reducers/reducer-needs-transport-questions";
import { refreshReducersToInitial } from "./refreshData-action";

export const UPDATE_NEEDS_TRANSPORT_QUESTIONS = "UPDATE_NEEDS_TRANSPORT_QUESTIONS" as const;
export const CLEAR_NEEDS_TRANSPORT_QUESTIONS = "CLEAR_NEEDS_TRANSPORT_QUESTIONS" as const;

export const updateNeedsTransportQuestions = (payload: NeedsTransportResponse) =>
  ({
    type: UPDATE_NEEDS_TRANSPORT_QUESTIONS,
    payload,
  } as const);

export const clearNeedsTransportQuestions = () =>
  ({
    type: CLEAR_NEEDS_TRANSPORT_QUESTIONS,
  } as const);

export type NeedsTransportQuestionActions =
  | ReturnType<typeof updateNeedsTransportQuestions>
  | ReturnType<typeof clearNeedsTransportQuestions>
  | ReturnType<typeof refreshReducersToInitial>;
